import React, {Component} from 'react';
import {Link} from 'react-router-dom'
import '../framework/SpreadTable/spread-table.css';
import ArrowDown from 'material-ui/svg-icons/navigation/arrow-drop-down';
import ArrowUp from 'material-ui/svg-icons/navigation/arrow-drop-up';
import isEqual from 'lodash/isEqual';

const arrowStyles = {
  position: 'absolute',
  right: '5px',
  top: '5px'
}
class CampaignsTable extends Component {
  constructor (props) {
    super(props);
    this.state = {
      activeIndex: props.activeIndex,
      arrowActive: 'down',
      bodyData:props.bodyDataArr
    }
  }

  componentWillReceiveProps(nextProps) {
		if (!isEqual(nextProps.bodyDataArr.slice().sort(), this.props.bodyDataArr.slice().sort())) {
      /*
      let sortField = ""
      switch(this.state.activeIndex){
        case 0:
          sortField = "name";
          break;
        case 1:
          sortField = "campaignId";
          break;
        case 2:
          sortField = "clientCampaignId";
          break;
        case 4:
          sortField = "startDate";
          break;
        case 5:
          sortField = "endDate";
          break;
        case 3:
          sortField = "status";
          break;
        default:
          sortField = "name";
          break;
      }*/
  
      /*const list = this.state.arrowActive === 'up' ? sortBy(nextProps.bodyDataArr, (data)=>{
        return data[sortField];
      }) : reverse(sortBy(nextProps.bodyDataArr, (data)=>{
        return data[sortField];
      }))*/

			this.setState({
				bodyData: nextProps.bodyDataArr
      })
		}
  }

  handleClick (index) {
    this.setState({
      activeIndex: index
    });
    let sortDesc = false
    if (+index === this.state.activeIndex) {
      if (this.state.arrowActive === 'down') {
        this.setState({
          arrowActive: 'up'
        })
      } else {
        this.setState({
          arrowActive: 'down'
        })
        sortDesc = true;
      }
    } else {
      this.setState({
        arrowActive: 'down'
      })
      sortDesc = true;
    }

    let sortField = ""
    switch(index){
      case 0:
        sortField = "campaignName";
        break;
      case 1:
        sortField = "campaignId";
        break;
      case 2:
        sortField = "clientCampaignId";
        break;
      case 4:
        sortField = "startDate";
        break;
      case 5:
        sortField = "endDate";
        break;
      case 3:
        sortField = "status";
        break;
      default:
        sortField = "campaignName";
        break;
    }


    this.props.handleSearch(sortField, sortDesc);
/*
    const list = sortDesc ? reverse(sortBy(this.state.bodyData, (data)=>{
      return data[sortField];
    })) : sortBy(this.state.bodyData, (data)=>{
      return data[sortField];
    })

    this.setState({
      bodyData: list
    })*/
  }

  render () {
    return (
      <div className="spread-table">
        <table>
          <tbody>
          <tr>
            {this.props.tableHeaderArr.map((item, index) => {
              let widthStyle = '';
              switch (index) {
                case 0:
                  widthStyle = this.props.tableHeaderWidthStyle[0];
                  break;
                case 1:
                  widthStyle = this.props.tableHeaderWidthStyle[1];
                  break;
                case 2:
                  widthStyle = this.props.tableHeaderWidthStyle[2];
                  break;
                case 3:
                  widthStyle = this.props.tableHeaderWidthStyle[3];
                  break;
                case 4:
                  widthStyle = this.props.tableHeaderWidthStyle[4];
                  break;
                case 5:
                  widthStyle = this.props.tableHeaderWidthStyle[5];
                  break;
                case 6:
                  widthStyle = this.props.tableHeaderWidthStyle[6];
                  break;
                default:
                  widthStyle = '';
                  break;
              }
              return (
                <th key={item.value}
                    className={this.state.activeIndex === index? 'active no-padding-right' : 'no-padding-right'}
                    onClick={(e) => {this.props.sortable ? this.handleClick(index) : e.preventDefault(); }}
                    style={{width: widthStyle, whiteSpace: 'pre-wrap'}}
                >
                  {item.label}
                  {
                    (
                      this.state.activeIndex === index && this.props.sortable &&
                      this.state.arrowActive === 'down'
                    ) && (
                      <ArrowDown
                        style={{
                          ...arrowStyles
                        }}
                      />
                    )
                  }
                  {
                    (
                      this.state.activeIndex === index && this.props.sortable && 
                      this.state.arrowActive === 'up'
                    ) && (
                      <ArrowUp
                        style={{
                          ...arrowStyles
                        }}
                      />
                    )
                  }
                </th>
              )
            })}
          </tr>
          {
            this.state.bodyData.map((item, index) => {
              return (
                <tr key={index}>
                  <td><Link className="campaign-name-link" to={'/campaigns/report/'+item.id}>{item.name}</Link></td>
									<td>{item.campaignId}</td>
									<td>{item.clientCampaignId ? item.clientCampaignId : ''}</td>
									<td>{item.status}</td>
									<td>{item.startDate}</td>
                  <td>{item.endDate}</td>
                  <td >{this.props.canEdit && 
                  <a style={{marginLeft:'-10px'}} onClick={(e) => {this.props.handleClickEditCampaign(e, item.id)}}>
						        <i className="icon-pencil4" style={{color:"#BEBEBE"}} />
					        </a>}
                  </td>
                </tr>
              )
						})
          }
          </tbody>

        </table>
      </div>
    )
  }
}

CampaignsTable.defaultProps = {
  tableHeaderWidthStyle: ['22%', '22%', '10%', '20%'],
  bodyDataArr: [],
  bodyDataKey: [],
  activeIndex: 4,
  renderCols: {
    addCol: '',
    cols: []
  },
  canEdit:false,
  sortable: true
}

export default CampaignsTable;



// WEBPACK FOOTER //
// ./src/components/Campaigns/CampaignsTable.jsx